/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkTimeAllocationParam
 */
export interface WorkTimeAllocationParam {
    /**
     * 
     * @type {string}
     * @memberof WorkTimeAllocationParam
     */
    id: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorkTimeAllocationParam
     */
    hours: number;
    /**
     * 
     * @type {Date}
     * @memberof WorkTimeAllocationParam
     */
    validFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkTimeAllocationParam
     */
    validTo: Date | null;
    /**
     * 
     * @type {string}
     * @memberof WorkTimeAllocationParam
     */
    workArea: string;
    /**
     * 
     * @type {string}
     * @memberof WorkTimeAllocationParam
     */
    team: string;
}

/**
 * Check if a given object implements the WorkTimeAllocationParam interface.
 */
export function instanceOfWorkTimeAllocationParam(value: object): value is WorkTimeAllocationParam {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('hours' in value) || value['hours'] === undefined) return false;
    if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
    if (!('validTo' in value) || value['validTo'] === undefined) return false;
    if (!('workArea' in value) || value['workArea'] === undefined) return false;
    if (!('team' in value) || value['team'] === undefined) return false;
    return true;
}

export function WorkTimeAllocationParamFromJSON(json: any): WorkTimeAllocationParam {
    return WorkTimeAllocationParamFromJSONTyped(json, false);
}

export function WorkTimeAllocationParamFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkTimeAllocationParam {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'hours': json['hours'],
        'validFrom': (new Date(json['validFrom'])),
        'validTo': (json['validTo'] == null ? null : new Date(json['validTo'])),
        'workArea': json['workArea'],
        'team': json['team'],
    };
}

export function WorkTimeAllocationParamToJSON(json: any): WorkTimeAllocationParam {
    return WorkTimeAllocationParamToJSONTyped(json, false);
}

export function WorkTimeAllocationParamToJSONTyped(value?: WorkTimeAllocationParam | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'hours': value['hours'],
        'validFrom': `${value['validFrom'].getFullYear()}-${String(value['validFrom'].getMonth()+1).padStart(2,'0')}-${String(value['validFrom'].getDate()).padStart(2,'0')}`,
        'validTo': value['validTo'] == null ? value['validTo'] : `${value['validTo'].getFullYear()}-${String(value['validTo'].getMonth()+1).padStart(2,'0')}-${String(value['validTo'].getDate()).padStart(2,'0')}`,
        'workArea': value['workArea'],
        'team': value['team'],
    };
}

